
import React, { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, Modal, message, Row, Col, Form, Dropdown } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "./userManagement.css";
import "antd/dist/reset.css";
import { Accounts_Query, Add_Multiple_Users, Current_Designation, Get_City, Get_States, GET_User_Details_User_Management_For_RootAdmin, Role_Account_Query, Remove_User, Update_User, Bulk_Upload, Bulk_Upload_Sheet, Verify_Employee_Id, List_Gender_From_Role, List_Employement_Type_From_Role, Get_User_Users_In_Excel_For_Role, Get_User_Types, GET_PERFORMANCE_DATA_EXCEL, UPLOAD_PERFORMANCE_EXCEL, GET_MANAGER_WITH_FULLNAME_EMPID_LOCATION } from "../../../../../services/userAPI";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import BulkUploadFiles from "../../../../../Images/bulk-upload-files -added-icon.png";
import TextInputField from "../../../../../reusableField/TextInputField2";
import { validationRegexAlphaNumeric, validationRegexAmount, validationRegexMobileNo, validationRegexOnlyAlpha, validationRegexOnlyAlpha6 } from "../../../../../regex/regex";
import { Breadcrumb } from 'antd';
import SelectDropdown from "react-select"
import dayjs from 'dayjs';
import ButtonAlignment from "./buttonalignment";
// import PageBreadcrumb from '../../../../../reusableField/PageBreadcrumb';
// import MastersConfiguration from "../mastersConfiguration";
import PaginationPrevious from "../../../../../Images/paginationPreviuosIcon.png";
import PaginationNext from "../../../../../Images/paginationNextIcon.png";
import { AgGridReact } from "ag-grid-react";
// import ThresholdsConfiguration from "../thresholdsConfiguration";
import ProfileImageUploader from "../../../../profileImageUploader";
import UploadModal from "./uploadModal";
import ClanCrewQuestionCampaignModal from "../../../../clanCrew/clanCrewQuestionModal";
import ClanCrewQuestionCampaignAnalytics from "../../../../clanCrew/clanCrewQuestionCampaignAnalytics";
import ClanCrewCreateCohortModal from "../../../../clanCrew/clanCrewCreateCohortModal";
import CustomNoRowsOverlay from "../../../../CustomNoRowsOverlay";
import BackIcon from "../../../../../Images/backIcon.png";
import HomeIcon from "../../../../../Images/homeIcon.png";
import { DownOutlined } from "@ant-design/icons";

// REPLACE WITH THIS:
const UserManagement = ({ index, roleId: propRoleId, accountId: propAccountId, name: propName, accountName: propAccountName }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const roleId =
        propRoleId ||
        location.state?.roleId ||
        localStorage.getItem("roleId");

    const accountId =
        propAccountId ||
        location.state?.accountId ||
        localStorage.getItem("accountId");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10000);
    const [paginationToken, setPaginationToken] = useState(null);
    const [touched, setTouched] = useState({})
    const [errors, setErrors] = useState({})
    const name = propName || location.state?.name;
    const accountName = propAccountName || location.state?.accountName;
    // const [showInitialLoading, setShowInitialLoading] = useState(true);

    const [isQuestionCampaignVisible, setIsQuestionCampaignVisible] = useState(false);
    const [isQuestionAnalyticsVisible, setIsQuestionAnalyticsVisible] = useState(false);
    const [isCreateCohortVisible, setIsCreateCohortVisible] = useState(false);

    const [isModalVisibleForPerformanceUpload, setIsModalVisibleForPerformanceUpload] = useState(false); // For performance upload
    const getActiveTabFromPath = () => {
        if (location.pathname.includes("masterConfiguration")) {
            return "masters-configuration";
        }

        if (location.pathname.includes("attendance-daily-norm")) {
            return "attendance-daily-norm";
        }

        if (location.pathname.includes("mark-holidays")) {
            return "holidays";
        }

        return "user-management";
    };
    const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

    useEffect(() => {
        setActiveTab(getActiveTabFromPath());
    }, [location.pathname]);

    const handleTabChange = (key) => {
        if (key === "masters-configuration") {
            navigate("/masterConfiguration", { state: { roleId, accountId, name, accountName } });
        } else if (key === "attendance-daily-norm") {
            navigate("/attendance-daily-norm", { state: { roleId, accountId, name, accountName } });
        } else if (key === "holidays") {
            navigate("/mark-holidays", { state: { roleId, accountId, name, accountName } });
        } else {
            navigate("/user-management", { state: { roleId, accountId, name, accountName } });
        }
    };

    const { data: jobRoleData, loading: jobRoleLoading, error: jobRoleError } = useQuery(Role_Account_Query, {
        variables: { id: roleId, accountId: accountId },
        skip: !roleId, // Skip query if roleId is not available
        fetchPolicy: "network-only",
    });

    const [loginConfig, setLoginConfig] = useState({
        numberLogin: false,
        emailLogin: false,
    });

    useEffect(() => {
        if (jobRoleData?.getAllJobrole?.[0]) {
            setLoginConfig({
                numberLogin: jobRoleData.getAllJobrole[0].numberLogin,
                emailLogin: jobRoleData.getAllJobrole[0].emailLogin,
            });
        }
    }, [jobRoleData]);

    // useEffect(() => {
    //     setActiveTab(getActiveTabFromPath());
    // }, [location.pathname]);

    // const handleNextToProductConfiguration = () => {
    //     if (activeTab === "masters-configuration") {
    //         navigate("/masterConfiguration", { state: { roleId, accountId, name, accountName } });
    //     }
    // };

    const [roleIds, setRoleIds] = useState(() => {
        return localStorage.getItem("roleId") || location.state?.roleId || null;
    });

    const [accountIds, setAccountIds] = useState(() => {
        return localStorage.getItem("accountId") || location.state?.accountId || null;
    });

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [roleOptions, setRoleOptions] = useState([])

    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [cityOptions, setCityOptions] = useState([])

    const [selectedDesignation, setSelectedDesignation] = useState(null);

    const [step, setStep] = useState(0);
    const [step1, setStep1] = useState(0);

    const { data: roleData } = useQuery(Role_Account_Query, {
        variables: { accountId: accountId ? parseInt(accountId) : null },
        fetchPolicy: "network-only",
        skip: !accountId,
    });
    // ✅ CORRECT
    const currentRole = roleData?.getAllJobrole?.find((r) => r.id === roleId);
    const safeAccountName = accountName || "";
    const safeRoleName = name || currentRole?.name || "";

    const handleNext = (e) => {
        // Prevent default form submission behavior
        e.preventDefault();
        e.stopPropagation();

        // Create a copy of the touched state
        const newTouched = { ...touched };

        const fieldsToValidate = [
            "employeeid",
            "firstName",
            "lastName",
            "gender",
            "dateOfBirth",
            "highestEducationQualification",
            "previousEmployer",
            "previousExperience",
        ];

        if (loginConfig.emailLogin && !loginConfig.numberLogin) {
            fieldsToValidate.push("employeeMailId");
        }
        if (loginConfig.numberLogin && !loginConfig.emailLogin) {
            fieldsToValidate.push("phoneNumber");
        }

        // Mark all fields as touched to trigger validation
        fieldsToValidate.forEach(field => {
            newTouched[field] = true;
        });

        setTouched(newTouched);

        // Validate form data
        const stepErrors = validateFirstStep(formData);
        const hasErrors = Object.keys(stepErrors).length > 0;

        // Set errors
        setErrors(prevErrors => ({ ...prevErrors, ...stepErrors }));

        if (!hasErrors) {
            setStep(1);
        }
    };

    const validateFirstStep = (data) => {
        const errors = {};
        if (!data.employeeid?.trim()) errors.employeeid = "Employee ID is required";
        if (loginConfig.emailLogin && !loginConfig.numberLogin) {
            if (!data.employeeMailId?.trim()) {
                errors.employeeMailId = "Employee Mail ID is required";
            } else if (!emailRegex.test(data.employeeMailId)) {
                errors.employeeMailId = "Invalid email format";
            }
        }
        if (loginConfig.numberLogin && !loginConfig.emailLogin) {
            if (!data.phoneNumber?.trim()) {
                errors.phoneNumber = "Phone number is required";
            } else if (!/^[6-9]\d{9}$/.test(data.phoneNumber.trim())) {
                errors.phoneNumber = "Invalid phone number format";
            }
        } else if (data.phoneNumber?.trim() && data.phoneNumber.trim().length !== 10) {
            errors.phoneNumber = "Phone number must be exactly 10 digits";
        }
        if (!data.firstName?.trim()) errors.firstName = "First name is required";
        if (!data.lastName?.trim()) errors.lastName = "Last name is required";
        // if (!data.phoneNumber?.trim()) errors.phoneNumber = "Phone Number is required";
        if (!data.dateOfBirth) errors.dateOfBirth = "Date of birth is required";
        if (!data.gender) errors.gender = "Gender is required";

        return errors;
    };

    const toggleSelectionMode = () => {
        setSelectionMode(!selectionMode);
        if (selectionMode) {
            setSelectedUsers([]);
        }
    };

    const handleExport = async () => {
        try {
            const api = gridApiRef.current;
            let displayedRows = [];

            // Helper to get the display value for a field (must match valueGetters in columnDefs)
            const getDisplayValue = (row, field) => {
                if (field === "joiningDate") {
                    if (!row.joiningDate) return "";
                    const date = new Date(row.joiningDate);
                    if (isNaN(date)) return row.joiningDate;
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                }
                if (field === "status") {
                    return row.profileActivated === true ? "Active" : "Inactive";
                }
                const val = row[field];
                return val === null || val === undefined ? "" : String(val);
            };

            if (api) {
                // Read the active filter model from the grid
                const filterModel = api.getFilterModel();

                if (filterModel && Object.keys(filterModel).length > 0) {
                    // Filters are active — apply them to tableData manually
                    displayedRows = [...tableData];
                    Object.keys(filterModel).forEach(field => {
                        const filter = filterModel[field];
                        if (filter && filter.filter) {
                            const filterValue = filter.filter.toLowerCase();
                            displayedRows = displayedRows.filter(row => {
                                const cellValue = getDisplayValue(row, field);
                                return cellValue.toLowerCase().includes(filterValue);
                            });
                        }
                    });
                } else {
                    // No filters active — export all current tableData
                    displayedRows = [...tableData];
                }
            } else {
                // Grid not ready — fallback to full tableData
                displayedRows = [...tableData];
            }

            if (displayedRows.length === 0) {
                message.warning("No data available to export.");
                return;
            }

            // Define the columns to export with optional value formatter
            const exportColumns = [
                { field: "id", header: "Employee ID" },
                { field: "name", header: "Name" },
                { field: "employeeMailId", header: "Email" },
                { field: "phoneNumber", header: "Phone" },
                { field: "designation", header: "Designation" },
                {
                    field: "joiningDate", header: "Date of Joining", formatter: (val) => {
                        if (!val) return "";
                        const date = new Date(val);
                        if (isNaN(date)) return val;
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                },
                { field: "cityName", header: "City" },
                { field: "branch", header: "Branch" },
                { field: "userType", header: "User Type" },
                { field: "profileActivated", header: "App Active/Inactive", formatter: (val) => val === true ? "Active" : "Inactive" },
            ];

            // Convert data to CSV format
            const csvHeader = exportColumns.map(col => col.header).join(",");
            const csvRows = displayedRows.map(row => {
                return exportColumns.map(col => {
                    let value = col.formatter ? col.formatter(row[col.field]) : (row[col.field] || "");
                    // Escape quotes and wrap in quotes if contains comma
                    if (typeof value === "string") {
                        value = value.replace(/"/g, '""');
                        if (value.includes(",") || value.includes('"') || value.includes("\n")) {
                            value = `"${value}"`;
                        }
                    }
                    return value;
                }).join(",");
            });

            const csvContent = [csvHeader, ...csvRows].join("\n");

            // Create blob and download
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `user_management_${new Date().toISOString().split('T')[0]}.csv`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            message.success(`Export completed successfully! (${displayedRows.length} records exported)`);
        } catch (error) {
            console.error("Error exporting data:", error);
            message.error("An error occurred while exporting data.");
        }
    };

    const handleExportClick = () => {
        handleExport();
    };

    const [formData, setFormData] = useState({
        fullTimeConsultant: "",
        currentBranch: "",
        employeeIdOfManager: "",
        nameOfManager: "",
        clientImage: "",
        imageUrl: "",
        mainLogoUrl: "",
        id: "",
        userId: null,
        dateOfJoining: null,
        currentDesignation: "",
        state: "",
        city: "",
        zone: "",
        dateOfReporting: null,
        employeeMailId: "",
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: null,
        highestEducationQualification: "",
        previousEmployer: "",
        previousExperience: "",
        phoneNumber: "",
    });

    const [addUsers, { loading: addUsersLoading, error: addUsersError, data: addUsersData }] = useMutation(Add_Multiple_Users);

    const [formDataList, setFormDataList] = useState([
        {
            fullTimeConsultant: null,
            dateOfJoining: null,
            currentDesignation: "",
            currentBranch: "",
            state: "",
            city: "",
            zone: "",
            employeeIdOfManager: "",
            dateOfReporting: null,
            nameOfManager: "",
        }
    ])
    const [selectedDate, setSelectedDate] = useState(null);
    const [cursor, setCursor] = useState(null);
    const { loading, error, data, refetch } = useQuery(
        GET_User_Details_User_Management_For_RootAdmin,
        {
            variables: {
                roleId: roleId,
                pagingCriteria: {
                    cursor: null,
                    limit: pageSize,
                    sortOrder: "asc",
                    sortByField: "name",
                },
            },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
            skip: !roleId || !accountId,
        }
    );

    // useEffect(() => {
    //     setShowInitialLoading(loading);

    //     // if (data && data.getUsersForAccount) {
    //     //     setShowInitialLoading(true);
    //     //     const timer = setTimeout(() => {
    //     //         setShowInitialLoading(false);
    //     //     }, );
    //     //     return () => clearTimeout(timer);
    //     // }
    // }, [loading]);
    // const users = data.getUsersForAccount.data;


    const pageMeta = data?.getUsersForAccount?.pageMeta;

    const totalCount = data?.getUsersForAccount?.pageMeta?.totalCount || 0;
    const totalPages = Math.ceil(totalCount / pageSize);
    const handlePrevious = () => {
        if (pageMeta?.hasPreviousPage) {
            setCursor(pageMeta.previousPage);
            setCurrentPage((prev) => Math.max(prev - 1, 1));
        }
    };

    const handleNextt = () => {
        if (pageMeta?.hasNextPage) {
            setCursor(pageMeta.nextPage);
            setCurrentPage((prev) => Math.min(prev + 1, totalPages));
        }
    };

    // Refetch when search or date filter changes
    useEffect(() => {
        if (roleId) {
            refetch({
                roleId,
                filterByName: searchTerm || null,
                joiningDateFilter: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
                pagingCriteria: {
                    cursor: null,
                    limit: pageSize,
                    sortOrder: "asc",
                    sortByField: "name"
                },
            });
        }
    }, [searchTerm, selectedDate, roleId]);
    const [form] = Form.useForm();

    const tableData = useMemo(() => {
        return (
            data?.getUsersForAccount?.data?.map((user, index) => ({
                key: user.UserId,
                UserId: user.id || null,
                id: user.employeeId || "",
                // name: user.name + " " + user.surname || "Unnamed User",
                name: user.fullname || "",
                employeeMailId: user.email || "",
                gender: user.gender || "",
                genderId: user.genderId || null,
                joiningDate: user.joiningDate || "",
                designation: user.designation || "",
                designationId: user.designationId || null,
                surname: user.surname || "",
                dateOfBirth: user.dateOfBirth || "",
                city: user.city || "",
                branch: user.branch || "",
                role: user.role || "",
                phoneNumber: user.phoneNumber || "",
                address: user.address || "",
                state: user.state || "",
                zone: user.zone || "",
                highestEducationQualification: user.highestEducationQualification || "",
                previousEmployer: user.previousEmployer || "",
                previousExperience: user.previousExperience ? Number(user.previousExperience) : 0,
                profileActivated: user.profileActivated || false,
                roleId: user.roleId || null,
                roleStartDate: user.roleStartDate || "",
                accountId: user.accountId || null,
                accountName: user.accountName || "",
                reportingDate: user.reportingDate || "",
                employeeId: user.employeeId || "",
                employeeIds: user.reporting?.employeeId || "",
                employeeName: user.reporting?.name || "",
                managerName: user.reporting?.name || "No Manager",
                stateName: user.stateName || "",
                cityName: user.cityName || "",
                employeeType: user.employeeType || "",
                employeeTypeId: user.employeeTypeId || null,
                numberOfAssociates: user.numberOfAssociates || 0,
                numberOfManagers: user.numberOfManagers || 0,
                status: user.status || 0,
                userType: user.userType?.userType || "",
            })) || []
        );
    }, [data?.getUsersForAccount?.data]);

    const handleView = (userId) => {
        navigate(`/user/${userId}`, {
            state: {
                name: name || "",
                accountName: accountName || "",
                roleId: roleId || null,
                accountId: accountId || null,
            },
        });
    };

    // Add to existing state
    const gridApiRef = useRef(null);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridReady, setGridReady] = useState(false);
    const [displayedRowCount, setDisplayedRowCount] = useState(null);

    const [getUsersInExcel, { loading: exportLoading, data: exportData, error: exportError }] = useLazyQuery(Get_User_Users_In_Excel_For_Role, {
        fetchPolicy: "network-only",
    });

    // Column Definitions
    const columnDefs = useMemo(() => [
        {
            headerName: "Employee ID",
            headerTooltip: "Employee ID",
            field: "id",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
        },
        {
            headerName: "Name",
            headerTooltip: "Name",
            field: "name",
            width: 180,
            minWidth: 180,
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            cellRenderer: (params) => (
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => handleView(params.data.UserId)}
                >
                    {params.value}
                </span>
            ),
        },
        {
            headerName: "Email",
            headerTooltip: "Email",
            field: "employeeMailId",
            sortable: true,
            width: 180,
            minWidth: 180,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => params.data?.employeeMailId || "",
        },
        { headerName: "Phone", headerTooltip: "Phone", field: "phoneNumber", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        { headerName: "Designation", headerTooltip: "Designation", field: "designation", width: 200, minWidth: 200, sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        { headerName: "Manager", headerTooltip: "Manager", field: "managerName", width: 200, minWidth: 200, sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        {
            headerName: "Date of Joining",
            headerTooltip: "Date of Joining",
            field: "joiningDate",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => {
                if (!params.data?.joiningDate) return "";
                const date = new Date(params.data.joiningDate);
                if (isNaN(date)) return params.data.joiningDate;
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            },
        },
        { headerName: "City", headerTooltip: "City", field: "cityName", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        { headerName: "Branch", headerTooltip: "Branch", field: "branch", sortable: true, filter: "agTextColumnFilter", floatingFilter: true, },
        {
            headerName: "User Type",
            headerTooltip: "User Type",
            field: "userType",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => params.data?.userType || "",
        },
        {
            headerName: "App Active/Inactive",
            headerTooltip: "App Active/Inactive",
            field: "status",
            sortable: true,
            filter: "agTextColumnFilter",
            floatingFilter: true,
            valueGetter: (params) => {
                const profileActivated = params.data?.profileActivated;
                return profileActivated === true ? "Active" : "Inactive";
            },
        },
    ], []);

    // Default Column Definitions
    const defaultColDef = useMemo(() => ({
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: "agTextColumnFilter",
        floatingFilter: true,
        cellStyle: { padding: "10px" },
        tooltipValueGetter: (params) => params.value,
        suppressMenu: false,
    }), []);

    // Grid Ready Handler
    const onGridReady = (params) => {
        gridApiRef.current = params.api;
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        setGridReady(true);
    };

    const onFilterChanged = (params) => {
        if (params?.api) {
            const isFilterActive = params.api.isAnyFilterPresent();
            if (isFilterActive) {
                const filterModel = params.api.getFilterModel();
                let filteredData = [...tableData];

                const getDisplayVal = (row, field) => {
                    if (field === "joiningDate") {
                        if (!row.joiningDate) return "";
                        const date = new Date(row.joiningDate);
                        if (isNaN(date)) return row.joiningDate;
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                    if (field === "status") {
                        return row.profileActivated === true ? "Active" : "Inactive";
                    }
                    const val = row[field];
                    return val === null || val === undefined ? "" : String(val);
                };

                Object.keys(filterModel).forEach(field => {
                    const filter = filterModel[field];
                    if (filter && filter.filter) {
                        const filterValue = filter.filter.toLowerCase();
                        filteredData = filteredData.filter(row => {
                            const cellValue = getDisplayVal(row, field);
                            return cellValue.toLowerCase().includes(filterValue);
                        });
                    }
                });

                setDisplayedRowCount(filteredData.length);
                if (filteredData.length === 0) {
                    params.api.showNoRowsOverlay();
                } else {
                    params.api.hideOverlay();
                }
            } else {
                setDisplayedRowCount(null);
                params.api.hideOverlay();
            }
        }
    };

    const noRowsOverlayComponent = () => {
        // return <CustomNoRowsOverlay message="No users found" />;
    };

    const onSelectionChanged = () => {
        if (gridApi) {
            const selectedRows = gridApi.getSelectedRows();
            setSelectedUsers(selectedRows.map(row => row.key));
        }
    };

    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = (e) => {
        if (e) e.preventDefault();
        setStep(0);
        setStep1(0);
        setIsModalVisible(false);
        // Reset Ant Design form
        form.resetFields();
        // Reset form data
        setFormData({
            fullTimeConsultant: "",
            currentBranch: "",
            employeeIdOfManager: "",
            nameOfManager: "",
            clientImage: "",
            imageUrl: "",
            mainLogoUrl: "",
            id: "",
            userId: null,
            dateOfJoining: null,
            currentDesignation: "",
            state: "",
            city: "",
            zone: "",
            dateOfReporting: null,
            employeeid: "",
            employeeMailId: "",
            firstName: "",
            lastName: "",
            gender: "",
            dateOfBirth: null,
            highestEducationQualification: "",
            previousEmployer: "",
            previousExperience: "",
            phoneNumber: "",
        });

        // Reset select dropdowns state variables
        setSelectedCompany(null);
        setSelectedRole(null);
        setSelectedDesignation(null);
        setSelectedState(null);
        setSelectedCity(null);
        setManagerName("No Manager");
        setRoleOptions([]);
        // Reset form data list if using it
        setFormDataList([
            {
                fullTimeConsultant: "",
                dateOfJoining: null,
                currentDesignation: "",
                currentBranch: "",
                state: "",
                city: "",
                zone: "",
                employeeIdOfManager: "",
                dateOfReporting: null,
                nameOfManager: "No Manager",
            }
        ]);

        // Reset validation state
        setTouched({});
        setErrors({});
    };

    const handleInputChange = (e, field, index) => {
        const { name, value } = e.target || e;
        const fieldName = field || name;
        // Ensure correct data type for previousExperience
        const updatedValue = fieldName === "previousExperience" && value !== ""
            ? parseInt(value, 10)
            : value;

        // Update form data
        if (index !== undefined) {
            setFormDataList(prevList =>
                prevList.map((item, idx) =>
                    idx === index ? { ...item, [fieldName]: updatedValue } : item
                )
            );
        } else {
            setFormData(prev => ({
                ...prev,
                [fieldName]: updatedValue
            }));
        }

        setTouched(prev => ({
            ...prev,
            [index !== undefined ? `${index}-${fieldName}` : fieldName]: true
        }));

        // Email validation
        if (fieldName === "employeeMailId") {
            if (!value.trim()) {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: ""
                }));
            } else if (!emailRegex.test(value)) {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: "Invalid email format"
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: undefined
                }));
            }
        } else {
            // Clear errors for other fields
            if (index !== undefined) {
                setErrors(prev => ({
                    ...prev,
                    [`${index}-${fieldName}`]: undefined
                }));
            } else {
                setErrors(prev => ({
                    ...prev,
                    [fieldName]: undefined
                }));
            }
        }
        // Mark as touched
        setTouched(prev => ({
            ...prev,
            [index !== undefined ? `${index}-${fieldName}` : fieldName]: true
        }));
    };

    const removeUserFields = (index) => {
        setFormDataList(formDataList.filter((_, i) => i !== index));
    };

    const handleDateChange = (name, date) => {
        // Convert the date to a normal date string (YYYY-MM-DD format)
        const normalDate = date ? date.format('YYYY-MM-DD') : null;
        setFormData((prevData) => ({
            ...prevData,
            [name]: normalDate, // Use the normalized date string
        }));

        setTouched((prevTouched) => ({
            ...prevTouched,
            [name]: true,
        }));

        // Clear the error for this field if it has a value
        if (normalDate) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: undefined
            }));
        }
    };

    const handleListDateChange = (index, field, date) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, [field]: date } : item // Keep as Date object
            )
        );
    };

    const handleSubmit = async (e) => {
        const formValues = form.getFieldsValue(true);
        const formatDate = (dateValue) => {
            if (!dateValue) return null;

            try {
                const date = new Date(dateValue);
                if (isNaN(date.getTime())) return null;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            } catch (error) {
                console.error("Invalid date format:", dateValue);
                return null;
            }
        };

        localStorage.setItem("roleId", roleId);
        localStorage.setItem("accountId", accountId);

        // Map your form data to the expected API structure
        const userData = formDataList.map((item, index) => {
            // Find gender ID based on selected gender name
            const selectedGender = genderOptions.find(option => option.value === (formData.gender || item.gender));
            const selectedEmployementTypeId = employementOptions.find(option => option.value === (formData.fullTimeConsultant || item.fullTimeConsultant));
            const selectedUserType = userTypesOptions.find(option => option.value === (formData.userType || item.userType));
            const genderId = selectedGender ? selectedGender.id : null; // Ensure genderId is sent

            return {
                accountId: accountId || null,
                currentRoleId: roleId || null,
                employeeId: formData.employeeid || item.employeeid || "",
                firstName: formData.firstName || item.firstName || "",
                lastName: formData.lastName || item.lastName || "",
                email: formData.employeeMailId || item.employeeMailId || "",
                phoneNumber: formData.phoneNumber || item.phoneNumber || "",

                genderId: selectedGender ? selectedGender.value : null,  // Send ID
                employeeTypeId: selectedEmployementTypeId ? selectedEmployementTypeId.value : null,  // Send ID

                dateOfBirth: (formData.dateOfBirth || item.dateOfBirth) ? formatDate(formData.dateOfBirth || item.dateOfBirth) : "",
                joiningDate: (formData.dateOfJoining || item.dateOfJoining) ? formatDate(formData.dateOfJoining || item.dateOfJoining) : "",
                validFrom: (formData.dateOfReporting || item.dateOfReporting) ? formatDate(formData.dateOfReporting || item.dateOfReporting) : null,

                higestEducationQualification: formData.highestEducationQualification || item.highestEducationQualification || "",
                previousEmployer: formData.previousEmployer || item.previousEmployer || "",
                managerEmployeeId: formData.employeeIdOfManager || item.employeeIdOfManager || null,
                designation: selectedDesignation?.value ? (selectedDesignation.value) : "Unknown",
                state: selectedState?.value ? (selectedState.value) : "Unknown",
                city: selectedCity?.value ? (selectedCity.value) : "Unknown",

                zone: item.zone?.value || item.zone || "Unknown",
                location: item.location || "Unknown",
                userId: null,
                branch: item.currentBranch || "Unknown",
                previousExperience: (formData.previousExperience || item.previousExperience)
                    ? parseInt(formData.previousExperience || item.previousExperience, 10)
                    : 0,
                userTypeId: selectedUserType?.value ? (selectedUserType.value) : null,
            };
        });

        try {
            const response = await addUsers({ variables: { data: userData } });
            const result = response?.data?.addMultipleUsers;
            const success = result?.success;
            const userErrors = result?.data || [];

            if (success) {
                message.success("Users added successfully!");
                handleCancel(false); // Assuming you have a state to control modal visibility

                // Reset form fields (optional)
                form.resetFields();
                await refetch();
                setRoleIds(localStorage.getItem("roleId"));
                setAccountIds(localStorage.getItem("accountId"));
                // fetchDesignations({ variables: { jobroleId: Number(localStorage.getItem("roleId")) } });
            } else {
                userErrors.forEach((error) => {
                    if (error?.message) {
                        message.error(error.message); // e.g., "employee id already exists"
                    }
                });

                console.error("User addition failed:", response.data);
            }
        } catch (error) {
            console.error("GraphQL Error:", error);
            message.error("Failed to add users due to a system error.");
        }
    }

    const userTypeOptions = [
        { label: "North", value: "north" },
        { label: "South", value: "south" },
        { label: "East", value: "east" },
        { label: "West", value: "west" }
    ];

    const handleDesignationChange = (selectedOption) => {
        setSelectedDesignation(selectedOption);

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.currentDesignation; // Clears the error dynamically
            return newErrors;
        });

        setTouched(prevTouched => ({
            ...prevTouched,
            currentDesignation: true, // Mark as touched
        }));
    };

    const handleZoneChange = (selectedOption, index) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, zone: selectedOption } : item
            )
        );

        form.setFieldsValue({
            [index]: {
                ...form.getFieldValue(index),
                zone: selectedOption || ""
            }
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-zone`]; // Remove error dynamically
            return newErrors;
        });

        setTouched(prevTouched => ({
            ...prevTouched,
            [`${index}-zone`]: true, // Mark as touched per index
        }));
    }

    const [isModalVisibleForUpload, setIsModalVisibleForUpload] = useState(false);
    const showModalForUpload = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsModalVisibleForUpload(true);
    }
    const handleCancelUpload = () => setIsModalVisibleForUpload(false);

    const [bulkUploadUsers, { bulkUploadloading, bulkUploaderror, data: bulkUploadData }] = useMutation(Bulk_Upload);
    const [file, setFile] = useState(null);

    const handleUpload = async () => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("accountId", accountId || ""); // Ensure company ID is sent
        formData.append("currentRoleId", roleId || "");

        try {
            const response = await bulkUploadUsers({
                variables: {
                    accountId: accountId,
                    roleId: roleId,
                    document: file,
                },
            });
            const uploadResult = response?.data?.bulkUploadUsers;
            if (uploadResult?.success) {
                message.success("File uploaded successfully!");
            } else {
                message.error(uploadResult?.message || "File upload failed");
            }
            setFile(null);
            setSelectedCompany(null);
            handleCancelUpload();
            navigate("/bulk-leads-result", {
                state: {
                    data: response.data,
                    fileName: file.name,
                    accountId,
                    roleId,
                    accountName,
                    name,
                },
            });
        } catch (err) {
            console.error("Upload error:", err);
            message.error("File upload failed. Please try again.");
            navigate("/bulk-leads-result", {
                state: {
                    data: null,
                    fileName: file.name,
                    accountId,
                    roleId,
                    accountName,
                    name,
                },
            });
        }
    };

    const { data: stateData, stateLoading, stateError } = useQuery(Get_States);
    const stateOptions = stateData?.getStates?.map((state) => ({
        value: state.id,
        label: state.stateName,
    })) || [];

    const { companyloading, companyerror, data: companyName } = useQuery(Accounts_Query);
    const companyOptions = companyName?.allUserAccount?.map((company) => ({
        value: company.id,
        label: company.name,
    })) || [];

    const [fetchCities, { loading: citiesLoading, error: citiesError }] = useLazyQuery(Get_City, {
        fetchPolicy: "network-only", // Ensures fresh data on every request
        onCompleted: (data) => {
            const roles = data?.getCity?.map((city) => ({
                value: city.id,
                label: city.cityName,
            })) || [];
            setCityOptions(roles);
        },
    });

    const handleUserTypeChange = (selectedOption, index) => {
        setFormDataList(prevList =>
            prevList.map((item, idx) =>
                idx === index ? { ...item, userType: selectedOption.value } : item
            )
        );
        form.setFieldsValue({
            [index]: {
                ...form.getFieldValue(index),
                userType: selectedOption || ""
            }
        });
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors[`${index}-userType`];
            return newErrors;
        });
        setTouched(prevTouched => ({
            ...prevTouched,
            [`${index}-userType`]: true,
        }));
    };

    const { loading: userTypesLoading, error: userTypesError, data: userTypesData } = useQuery(Get_User_Types, {
        fetchPolicy: "network-only",
    });

    const userTypesOptions = userTypesData?.getUserTypes?.map((type) => ({
        value: type.id,
        label: type.userType,
    })) || [];

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setSelectedCity(null);
        setCityOptions([]); // Reset roles when company changes

        if (selectedOption?.value) {
            fetchCities({ variables: { stateId: parseInt(selectedOption.value, 10) } });
        }

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.state;
            return newErrors;
        });
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.city;
            return newErrors;
        });
    };

    useEffect(() => {
        if (location.state?.roleId && location.state?.roleId !== roleIds) {
            setRoleIds(location.state.roleId);
            localStorage.setItem("roleId", location.state.roleId);
        }

        if (location.state?.accountId && location.state?.accountId !== accountIds) {
            setAccountIds(location.state.accountId);
            localStorage.setItem("accountId", location.state.accountId);
        }
    }, [location.state?.roleId, location.state?.accountId]);

    const [getBulkUploadExcel, { loading: downloadLoading, data: downloadData, error: downloadError }] = useLazyQuery(Bulk_Upload_Sheet);

    const handleDownload = () => {
        getBulkUploadExcel({ variables: { roleId: Number(roleId) } });
    };

    useEffect(() => {
        if (downloadData && downloadData.getBulkUploadExcel) {

            // Get the URL from the response
            const fileUrl = downloadData.getBulkUploadExcel;

            // Create an anchor element to trigger the download
            const a = document.createElement('a');
            a.href = fileUrl;
            a.download = 'Bulk_Upload_Sheet.xlsx';
            a.style.display = 'none'; // Hide the element
            document.body.appendChild(a);

            // Trigger the click event
            setTimeout(() => {
                a.click();
                // Clean up
                document.body.removeChild(a);
            }, 100);
        }

        if (downloadError) {
            console.error("API Error:", downloadError);
        }
    }, [downloadData, downloadError]);

    const [managerName, setManagerName] = useState("No Manager");  // Default to "No Manager"
    const [selectedManagerEmployeeId, setSelectedManagerEmployeeId] = useState("");  // Store selected manager's employee ID
    const [managerSearchTerm, setManagerSearchTerm] = useState("");  // For manager dropdown search

    // Fetch managers list for dropdown
    const { data: managersListData, loading: managersListLoading } = useQuery(GET_MANAGER_WITH_FULLNAME_EMPID_LOCATION, {
        variables: {
            roleId: parseInt(roleId) || 0,
            searchTerm: managerSearchTerm || "",
            pagingCriteria: {
                limit: 50,
                cursor: null,
                sortByField: "created_at",
                sortOrder: "desc",
            },
        },
        skip: !roleId,
        fetchPolicy: "network-only",
    });

    // Build manager options for dropdown - show "Full Name + Employee ID + Location"
    const managerOptions = useMemo(() => {
        if (!managersListData?.getManagerWithFullnameEmpidLocation?.data) return [];
        return managersListData.getManagerWithFullnameEmpidLocation.data.map((manager) => {
            const fullName = [manager.name, manager.surname].filter(Boolean).join(' ');
            const location = manager.location || manager.cityName || '';
            const labelParts = [fullName, manager.employeeId, location].filter(Boolean);
            return {
                value: manager.id,
                label: labelParts.join(' | '),
                employeeId: manager.employeeId,
                name: fullName,
                location: location,
            };
        });
    }, [managersListData]);

    // Handle manager selection from dropdown
    const handleManagerSelect = (selectedOption, index) => {
        if (selectedOption) {
            setSelectedManagerEmployeeId(selectedOption.employeeId || "");
            setManagerName(selectedOption.name || "No Manager");
            // Update form data with the manager's employee ID
            const updatedFormDataList = [...formDataList];
            updatedFormDataList[index] = {
                ...updatedFormDataList[index],
                employeeIdOfManager: selectedOption.employeeId,
            };
            setFormDataList(updatedFormDataList);
        } else {
            setSelectedManagerEmployeeId("");
            setManagerName("No Manager");
            // Clear employeeIdOfManager when manager is removed
            const updatedFormDataList = [...formDataList];
            updatedFormDataList[index] = {
                ...updatedFormDataList[index],
                employeeIdOfManager: null,
            };
            setFormDataList(updatedFormDataList);
        }
    };

    const [fetchManager, { data: employeeIdData, loading: employeeIdLoading, error: employeeIdError }] = useLazyQuery(Verify_Employee_Id);

    const handleImageUpdate = (newImageUrl) => {
        // Only update if needed for UserManagement (e.g., current user preview)
        // Avoid propagating to table area
    };

    useEffect(() => {
        if (employeeIdData?.verifyEmployeeId) {
            // Set the manager's name in state
            const managerName = employeeIdData.verifyEmployeeId.name || "No Manager";
            setManagerName(managerName);  // Update state
        } else {
            setManagerName("No Manager");
        }
    }, [employeeIdData]);  // Dependency array - rerun whenever employeeIdData changes

    const handleDiscardClick = () => {
        navigate("/admin");
    };

    const { loading: genderLoading, error: genderError, data: genderData } = useQuery(List_Gender_From_Role, {
        variables: { jobroleId: roleId }, // Ensure roleId is correctly defined
    });

    // Check if genderData exists before mapping
    const genderOptions = genderData?.listGenderFromRole
        ? genderData.listGenderFromRole.map((gender) => ({
            value: gender.id,
            label: gender.name,
        }))
        : [];


    const { loading: employementLoading, error: employementError, data: employementData } = useQuery(
        List_Employement_Type_From_Role,
        { variables: { jobRoleId: roleId } } // Ensure roleId is defined
    );

    // Convert API response into dropdown options
    const employementOptions = employementData?.listEmployementTypeFromRole?.map((type) => ({
        value: type.id,   // Store the ID
        label: type.name, // Display the name
    })) || [];

    const { loading: designationsLoading, error: designationsError, data: designationsData } = useQuery(
        Current_Designation,
        { variables: { jobroleId: roleId } } // Ensure roleId is defined
    );

    // Convert API response into dropdown options
    const designationOptions = designationsData?.getDesignationsJobroleid?.map((type) => ({
        value: type.id,   // Store the ID
        label: type.designation, // Display the name
    })) || [];


    const handleBack = () => {
        navigate("/admin"); // This will navigate back to the previous page
    }

    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;

    const handleBackToViewRole = () => {
        // Use existing roleId and accountName from location.state, with fallbacks
        const safeRoleId = roleId || location.state?.roleId;
        const safeAccountName = accountName || location.state?.accountName;

        // REPLACE navigate target only:
        navigate("/experience-configuration", {   // ✅ CORRECT
            state: {
                roleId: safeRoleId,
                accountId: accountId || location.state?.accountId,
                accountName: safeAccountName,
                name: name || location.state?.name,
                dartsNeeded: dartsNeeded || location.state?.dartsNeeded,
                clanNeeded: clanNeeded || location.state?.clanNeeded,
                syncNeeded: syncNeeded || location.state?.syncNeeded,
                dartsFormNeeded: dartsFormNeeded || location.state?.dartsFormNeeded,
                pocName: pocName || location.state?.pocName,
                pocEmail: pocEmail || location.state?.pocEmail,
                pocNumber: pocNumber || location.state?.pocNumber,
                numberLogin: numberLogin || location.state?.numberLogin,
                emailLogin: emailLogin || location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution || location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays || location.state?.targetEditDays,
                inputEditDays: inputEditDays || location.state?.inputEditDays,
            },
        });
    };

    const [getPerformanceDataExcel, { loading: performanceDataLoading, data: performanceData, error: performanceDataError }] = useLazyQuery(GET_PERFORMANCE_DATA_EXCEL, {
        fetchPolicy: "network-only",
    });

    const handleDownloadPerformanceData = async () => {
        if (!accountId || !roleId) {
            message.error("Account ID or Role ID is missing. Cannot download performance data.");
            return;
        }

        try {
            const { data } = await getPerformanceDataExcel({
                variables: {
                    accountId: Number(accountId),
                    jobroleId: Number(roleId),
                },
            });

            if (data?.getPerformanceDataExcel) {
                const fileUrl = data.getPerformanceDataExcel;
                const link = document.createElement("a");
                link.href = fileUrl;
                link.download = `performance_data_${accountId}_${roleId}_${new Date().toISOString().split('T')[0]}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                message.success("Performance data downloaded successfully!");
            } else {
                message.error("Failed to retrieve performance data.");
            }
        } catch (error) {
            console.error("Error downloading performance data:", error);
            message.error("An error occurred while downloading performance data.");
        }
    };

    const [bulkUploadPerformance, { loading: performanceUploadLoading, error: performanceUploadError, data: performanceUploadData }] = useMutation(UPLOAD_PERFORMANCE_EXCEL); // Replace `Bulk_Upload` with `Bulk_Upload_Performance` if you have a specific mutation

    // Show performance upload modal
    const showModalForPerformanceUpload = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        setIsModalVisibleForPerformanceUpload(true);
    };

    // Cancel performance upload modal
    const handleCancelPerformanceUpload = () => {
        setIsModalVisibleForPerformanceUpload(false);
    };

    // Handle success for performance upload
    const handlePerformanceUploadSuccess = (data, fileName) => {
        if (data?.uploadPerformanceExcel?.success) {
            // message.success("Performance data uploaded successfully!");
            navigate("/experience-configuration", {
                state: {
                    data: data.uploadPerformanceExcel.data,
                    fileName: fileName,
                    success: true,
                    roleId,
                    accountId,
                    name,
                    accountName,
                },
            });
        } else {
            // message.error("Performance data upload failed. Check the error file for details.");
            navigate("/experience-configuration", {
                state: {
                    data: null,
                    fileName: fileName,
                    success: false,
                    errorFileUrl: data?.uploadPerformanceExcel?.message,
                    roleId,
                    accountId,
                    name,
                    accountName,
                },
            });
        }
        setIsModalVisibleForPerformanceUpload(false);
    };

    const bulkActionsMenu = {
        items: [
            {
                key: "export",
                label: "Export CSV/XLS",
            },
            {
                key: "performance-upload",
                label: "Performance Upload",
            },
            {
                key: "performance-download",
                label: "Performance Download",
            },
        ],
        onClick: ({ key }) => {
            if (key === "export") {
                handleExportClick();
            }

            if (key === "performance-upload") {
                showModalForPerformanceUpload({
                    preventDefault: () => { },
                    stopPropagation: () => { },
                });
            }

            if (key === "performance-download") {
                handleDownloadPerformanceData();
            }
        },
    };

    const checkInMenu = {
        items: [
            {
                key: "cohort",
                label: "Cohort",
            },
            {
                key: "push-question",
                label: "Push Question",
            },
            {
                key: "question-analytics",
                label: "question Analytics",
            },
        ],
        onClick: ({ key }) => {
            if (key === "cohort") {
                setIsCreateCohortVisible(true);
            }

            if (key === "push-question") {
                setIsQuestionCampaignVisible(true);
            }

            if (key === "question-analytics") {
                setIsQuestionAnalyticsVisible(true);
            }
        },
    };

    return (
        <div className="user-profile-container user-management-page">
            {isQuestionCampaignVisible && (
                <ClanCrewQuestionCampaignModal
                    visible={isQuestionCampaignVisible}
                    onCancel={() => setIsQuestionCampaignVisible(false)}
                    accountId={accountId}
                />
            )}

            {isQuestionAnalyticsVisible && (
                <ClanCrewQuestionCampaignAnalytics
                    visible={isQuestionAnalyticsVisible}
                    onCancel={() => setIsQuestionAnalyticsVisible(false)}
                />
            )}

            {isCreateCohortVisible && (
                <ClanCrewCreateCohortModal
                    visible={isCreateCohortVisible}
                    onCancel={() => setIsCreateCohortVisible(false)}
                    accountId={accountId}
                    onCohortCreated={(cohort) => {
                        console.log('Cohort created:', cohort);
                    }}
                />
            )}

            <div className=" mx-auto px-3">
                <div className="flex justify-between items-center w-full  mx-[-8.5px]">

                    {/* Back Button */}
                    <button
                        onClick={handleBackToViewRole}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={BackIcon}
                            alt="Back"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Back
                    </button>

                    {/* Home Button */}
                    <button
                        onClick={() => navigate("/admin")}
                        className="flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 mr-[-12.5px] rounded-lg text-sm font-semibold shadow-md hover:bg-[#A91513] transition-all duration-200"
                    >
                        <img
                            src={HomeIcon}
                            alt="Home"
                            className="w-[15px] h-[15px] object-contain"
                        />
                        Home
                    </button>

                </div>

                <div
                    className="flex items-center text-sm text-[#939393]"
                    style={{ marginTop: 12, marginLeft: "-5px" }}
                >
                    <span
                        onClick={() => navigate("/admin")}
                        className="cursor-pointer"
                    >
                        {safeAccountName}
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    <span
                        onClick={() =>
                            navigate("/admin", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        {safeRoleName}
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    {/* Role Name */}

                    <span
                        onClick={() =>
                            navigate("/experience-configuration", {
                                state: {
                                    roleId,
                                    accountId,
                                    name,
                                    accountName,
                                },
                            })
                        }
                        className="cursor-pointer"
                    >
                        Experience Configuration
                    </span>

                    <span className="mx-2 text-[14px]">›</span>

                    <span className="font-semibold text-gray-800">
                        Masters Configuration
                    </span>
                </div>
            </div>
            <>
                <ButtonAlignment
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    onTabChange={handleTabChange}
                />
                <div >
                    <div>


                        <div
                            className="actions-container-user-management"
                            >
                        {/* ADD USER */}
                        <button
                            type="button"
                            onClick={showModal}
                            style={{
                                backgroundColor: "#C21A17",
                                color: "#FFFFFF",
                                border: "none",
                                borderRadius: "6px",

                                fontFamily: "Arial, sans-serif",
                                fontSize: "16px",
                                fontWeight: "400",
                                lineHeight: "20px",

                                width: "101px",
                                minWidth: "101px",
                                maxWidth: "101px",

                                height: "41px",
                                minHeight: "41px",
                                maxHeight: "41px",

                                padding: "0",
                                margin: "0",

                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                                boxSizing: "border-box",
                                flex: "0 0 101px",
                                flexShrink: 0,

                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            }}
                        >
                            Add User
                        </button>

                        {/* BULK ACTIONS */}
                        <Dropdown
                            menu={bulkActionsMenu}
                            placement="bottomLeft"
                            trigger={["click"]}
                        >
                            <button
                                type="button"
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#3A3A3A",
                                    border: "1px solid #BDBDBD",
                                    borderRadius: "6px",
                                    fontWeight: "400",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "140px",
                                    height: "41px",
                                    padding: "0 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    boxSizing: "border-box",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <span>Bulk Actions</span>

                                <DownOutlined
                                    style={{
                                        fontSize: "11px",
                                        color: "#002B55",
                                        marginLeft: "8px",
                                    }}
                                />
                            </button>
                        </Dropdown>

                        {/* CHECK-IN */}
                        <Dropdown
                            menu={checkInMenu}
                            placement="bottomLeft"
                            trigger={["click"]}
                        >
                            <button
                                type="button"
                                style={{
                                    backgroundColor: "#fff",
                                    color: "#3A3A3A",
                                    border: "1px solid #BDBDBD",
                                    borderRadius: "6px",
                                    fontWeight: "400",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    width: "116px",
                                    height: "41px",
                                    padding: "0 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    boxSizing: "border-box",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12)",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <span>Check-in</span>

                                <DownOutlined
                                    style={{
                                        fontSize: "11px",
                                        color: "#002B55",
                                        marginLeft: "8px",
                                    }}
                                />
                            </button>
                        </Dropdown>
                    </div>
                    {/* <div className="search-container-user-management-download-upload">
    <div className="button-group-user-management-download-upload">
      
    <button
        onClick={handleDownloadPerformanceData}
        disabled={performanceDataLoading}
        style={{
            backgroundColor: "#AD0101",
            color: "#fff",
            border: "none",
            padding: "14px 28px",
            borderRadius: "6px",
            fontWeight: "600",
            fontSize: "16px",
            cursor: "pointer",
            minWidth: "240px",
        }}
    >
        {performanceDataLoading
            ? "Performance Downloading..."
            : "Performance Download"}
    </button>

        <button
        onClick={showModalForPerformanceUpload}
        style={{
            backgroundColor: "#fff",
            color: "#3A3A3A",
            border: "1px solid #D9D9D9",
            padding: "14px 28px",
            borderRadius: "6px",
            fontWeight: "500",
            fontSize: "16px",
            cursor: "pointer",
            minWidth: "200px",
        }}
    >
        Performance Upload
    </button>
    </div>
</div>

<div className="search-container-user-management">

    <div className="button-group-user-management">
         <button
        onClick={handleExportClick}
        style={{
            backgroundColor: "#fff",
            color: "#3A3A3A",
            border: "1px solid #D9D9D9",
            padding: "14px 28px",
            borderRadius: "6px",
            fontWeight: "500",
            fontSize: "16px",
            cursor: "pointer",
            minWidth: "200px",
        }}
    >
        Export CSV/XLS
    </button>
  <button
        onClick={showModal}
        style={{
            backgroundColor: "#AD0101",
            color: "#fff",
            border: "none",
            padding: "14px 28px",
            borderRadius: "6px",
            fontWeight: "600",
            fontSize: "16px",
            cursor: "pointer",
            minWidth: "180px",
        }}
    >
        Add User
    </button>
    </div>
</div> */}
                    </div>
                </div>

                <div className="tab-content">
                    <>
                        <div
                            className="ag-grid-wrapper"
                            style={{
                                width: "100%",
                                height: "600px",
                                overflowX: "hidden",
                                position: "relative"
                            }}
                        >
                            {loading && (
                                <div style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 10
                                }}>
                                    <div className="spinner-loader"></div>
                                </div>
                            )}
                            <AgGridReact
                                rowData={tableData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                pagination={true}
                                paginationPageSize={50}
                                paginationPageSizeSelector={[50, 100]}
                                onGridReady={onGridReady}
                                rowSelection="multiple"
                                onSelectionChanged={onSelectionChanged}
                                onFilterChanged={onFilterChanged}
                                className="user-management-ag-grid"
                                suppressCellFocus={true}
                                animateRows={false}
                                suppressHorizontalScroll={true}
                                noRowsOverlayComponent={noRowsOverlayComponent}
                                tooltipShowDelay={0}
                                rowBuffer={10}
                                suppressColumnVirtualisation={false}
                                debounceVerticalScrollbar={true}
                            />
                        </div>

                        <>
                            {false && (
                                <ProfileImageUploader
                                    onImageUpdate={handleImageUpdate}
                                    resetOnUnmount={true}
                                />
                            )}
                        </>

                        <div style={{ display: "flex", alignItems: "center", backgroundColor: "white", padding: "10px" }}>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
                                <div className="footer" style={{ textAlign: "right", fontFamily: "Inter" }}>
                                    Total users:{" "}
                                    <span style={{ fontWeight: 700, fontSize: "13px" }}>
                                        {displayedRowCount !== null && displayedRowCount !== tableData.length
                                            ? `${displayedRowCount} of ${tableData.length}`
                                            : tableData.length}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </>

            <Modal title="User Registration Form" open={isModalVisible} onCancel={handleCancel} footer={null} width={640} centered className="user-registration-modal">
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>
                        <a
                            style={{
                                fontWeight: step === 0 ? 'bold' : 'normal',
                                color: step === 0 ? '#AD0101' : 'rgb(188, 188, 188)', // Active: Red, Inactive: Blue
                            }}
                            onClick={() => setStep(0)}
                        >
                            1. User Basic Data
                        </a>

                    </Breadcrumb.Item>

                    <Breadcrumb.Item>
                        <a
                            // onClick={() => setStep(1)}
                            style={{
                                fontWeight: step === 1 ? 'bold' : 'normal',
                                color: step === 1 ? '#AD0101' : 'rgb(188, 188, 188)', // Active: Red, Inactive: Blue

                            }}
                        >
                            2. User Work Data
                        </a>
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Form form={form} layout="vertical" className="user-registratio{loginConfig.emailLogin && !loginConfig.numberLogin}n-form" onSubmit={(e) => e.preventDefault()}>
                    {step === 0 ? (
                        <>
                            <Row gutter={[16, 16]} className="registration-form-row">
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">
                                        Employee ID
                                        <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span>
                                    </label>
                                    <TextInputField
                                        name="employeeid"
                                        value={formData.employeeid || ""}
                                        placeholder="Employee ID"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAlphaNumeric}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleNext(e)}
                                    />
                                    {touched.employeeid && errors.employeeid && (
                                        <div className="createClientErrors">{errors.employeeid}</div>
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className={
                                        loginConfig.emailLogin && !loginConfig.numberLogin
                                            ? "required-label"
                                            : ""}
                                    >
                                        Employee Mail ID{loginConfig.emailLogin && !loginConfig.numberLogin && (
                                            <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span>
                                        )}
                                    </label>
                                    <TextInputField
                                        name="employeeMailId"
                                        value={formData.employeeMailId}
                                        placeholder="Employee Mail ID"
                                        feedbackMessage="Please enter a valid email address."
                                        // validationRegex={emailRegex}
                                        onChange={handleInputChange}
                                    />
                                    {touched.employeeMailId && errors.employeeMailId && (
                                        <div className="createClientErrors">{errors.employeeMailId}</div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]} className="registration-form-row">
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">First Name<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                    <TextInputField
                                        name="firstName"
                                        value={formData.firstName}
                                        placeholder="First Name"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha}
                                        onChange={handleInputChange}
                                    />
                                    {touched.firstName && errors.firstName && (
                                        <div className="createClientErrors">{errors.firstName}</div>
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">Last Name<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                    <TextInputField
                                        name="lastName"
                                        value={formData.lastName}
                                        placeholder="Last Name"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha}
                                        onChange={handleInputChange}
                                    />
                                    {touched.lastName && errors.lastName && (
                                        <div className="createClientErrors">{errors.lastName}</div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]} className="registration-gender-dob-row">
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">Gender<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                    <SelectDropdown
                                        options={genderOptions}
                                        classNamePrefix="registration-select"
                                        styles={{ container: (provided) => ({ ...provided, width: "100%" }) }}
                                        placeholder="Select Gender"
                                        value={genderOptions.find(option => option.value === formData.gender) || null} // Ensure no undefined access
                                        onChange={(selectedOption) =>
                                            handleInputChange({ target: { name: "gender", value: selectedOption.value } })
                                        }
                                        isSearchable
                                    />
                                    {touched.gender && errors.gender && (
                                        <div className="createClientErrors">{errors.gender}</div>
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">Date of Birth<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                    <DatePicker
                                        className="registration-date-picker"
                                        style={{ width: "100%" }}
                                        placeholder="Date of Birth"
                                        value={formData.dateOfBirth ? dayjs(formData.dateOfBirth, "YYYY-MM-DD") : null}
                                        onChange={(date) => handleDateChange("dateOfBirth", date)}
                                        defaultPickerValue={dayjs().subtract(18, "year")}
                                        disabledDate={(current) => {
                                            return current && current > dayjs().subtract(18, "year").endOf("day");
                                        }}
                                    />
                                    {touched.dateOfBirth && errors.dateOfBirth && (
                                        <div className="createClientErrors">{errors.dateOfBirth}</div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]} className="registration-form-row">
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">
                                        Highest Education Qualification
                                    </label>
                                    <TextInputField
                                        name="highestEducationQualification"
                                        value={formData.highestEducationQualification}
                                        placeholder="Highest Education Qualification"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexOnlyAlpha6}
                                        onChange={handleInputChange}
                                    />
                                    {touched.highestEducationQualification && errors.highestEducationQualification && (
                                        <div className="createClientErrors">{errors.highestEducationQualification}</div>
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">
                                        Previous Employer
                                    </label>
                                    <TextInputField
                                        name="previousEmployer"
                                        value={formData.previousEmployer}
                                        placeholder="Previous Employer"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAlphaNumeric}
                                        onChange={handleInputChange}
                                    />
                                    {touched.previousEmployer && errors.previousEmployer && (
                                        <div className="createClientErrors">{errors.previousEmployer}</div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]} className="registration-form-row">
                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className="required-label">
                                        Previous Experience (Months)
                                    </label>
                                    <TextInputField
                                        name="previousExperience"
                                        value={formData.previousExperience}
                                        placeholder="Previous Experience (Months)"
                                        feedbackMessage="Please input the current branch."
                                        validationRegex={validationRegexAmount}
                                        onChange={(e) => handleInputChange(e, "previousExperience")}
                                    />
                                    {touched.previousExperience && errors.previousExperience && (
                                        <div className="createClientErrors">{errors.previousExperience}</div>
                                    )}
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <label className={loginConfig.numberLogin && !loginConfig.emailLogin ? "required-label" : ""}>
                                        Phone Number{loginConfig.numberLogin && !loginConfig.emailLogin && (
                                            <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span>
                                        )}
                                    </label>
                                    <TextInputField
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        placeholder="Phone Number"
                                        maxLength={10}
                                        onChange={(value) => {
                                            const phoneValue = value?.target
                                                ? value.target.value
                                                : value || "";

                                            // Numbers only
                                            if (!/^\d*$/.test(phoneValue)) {
                                                return;
                                            }

                                            // First digit must be 6, 7, 8 or 9
                                            if (phoneValue.length > 0 && !/^[6-9]/.test(phoneValue)) {
                                                return;
                                            }

                                            // Maximum 10 digits
                                            if (phoneValue.length > 10) {
                                                return;
                                            }

                                            // Use your existing handler so errors are cleared
                                            handleInputChange(
                                                value?.target
                                                    ? value
                                                    : {
                                                        target: {
                                                            name: "phoneNumber",
                                                            value: phoneValue,
                                                        },
                                                    }
                                            );
                                        }}
                                    />
                                    {touched.phoneNumber && errors.phoneNumber && (
                                        <div className="createClientErrors">{errors.phoneNumber}</div>
                                    )}
                                </Col>
                            </Row>

                            <div
                                className="registration-basic-actions"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    width: "100%",
                                }}
                            >
                                {/* Left Buttons */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                    }}
                                >
                                    <button
                                        type="button"
                                        className="global-admin-bulk-upload-button"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            setIsModalVisibleForUpload(true);
                                        }}
                                    >
                                        Bulk Upload
                                    </button>

                                    <button
                                        type="button"
                                        className="handleDownload"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            handleDownload();
                                        }}
                                        disabled={downloadLoading}
                                    >
                                        Bulk Upload Sheet
                                    </button>
                                </div>

                                {/* Right Button */}
                                <div>
                                    <button
                                        className="nextButton"
                                        onClick={(e) => handleNext(e)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <Form
                                form={form}
                                className="user-work-data-form"
                                layout="vertical"
                                onFinish={handleSubmit}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                {formDataList?.map((formData, index, item) => (
                                    <div key={index} className="registration-user-record">
                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label>
                                                    Employment Type
                                                    <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span>
                                                </label>

                                                <Form.Item
                                                    name={["formDataList", index, "fullTimeConsultant"]}
                                                    rules={[
                                                        { required: true, message: "This field is required!" }
                                                    ]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={employementOptions}
                                                        placeholder="Select Employment Type"
                                                        value={formDataList[index]?.fullTimeConsultant || null} // Ensure a valid value
                                                        onChange={(selectedOption) => {
                                                            const updatedList = [...formDataList];
                                                            updatedList[index] = {
                                                                ...updatedList[index],
                                                                fullTimeConsultant: selectedOption.value
                                                            };
                                                            setFormDataList(updatedList);
                                                            form.setFieldsValue({
                                                                fullTimeConsultant: selectedOption.value
                                                            });
                                                        }}
                                                        isSearchable
                                                    />
                                                </Form.Item>

                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label>
                                                    Date of Joining
                                                    <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span>
                                                </label>

                                                <Form.Item
                                                    name={["formDataList", index, "dateOfJoining"]}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Date of Joining is required!",
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        placeholder="Date of Joining"
                                                        disabledDate={(current) => {
                                                            return current && current > dayjs().endOf("day");
                                                        }}
                                                        onChange={(date) =>
                                                            handleListDateChange(index, "dateOfJoining", date)
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">Current Designation<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>

                                                <Form.Item
                                                    name={["currentDesignation"]}
                                                    rules={[{ required: true, message: "Designation is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={designationOptions}
                                                        placeholder="Current Designation"
                                                        // isDisabled={!selectedRole}
                                                        // isLoading={designationLoading}
                                                        onChange={handleDesignationChange}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">Current Branch<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>

                                                <Form.Item
                                                    name={["formDataList", index, "currentBranch"]}
                                                    rules={[
                                                        { required: true, message: "Branch is required!" },
                                                        {
                                                            pattern: validationRegexOnlyAlpha,
                                                            message: "Only alphabets are allowed!",
                                                        },
                                                    ]}
                                                >
                                                    <TextInputField
                                                        placeholder="Current Branch"
                                                        feedbackMessage="Please input the current branch."
                                                        onChange={(e) => handleInputChange(e, "currentBranch", index)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">State<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>

                                                <Form.Item
                                                    name={["formDataList", index, "state"]}
                                                    rules={[{ required: true, message: "State is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={stateOptions}
                                                        placeholder="Select State"
                                                        isLoading={stateLoading}
                                                        onChange={handleStateChange}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">City<span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>

                                                <Form.Item
                                                    name={["formDataList", index, "city"]}
                                                    rules={[{ required: true, message: "City is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={cityOptions}
                                                        placeholder="Select City"
                                                        isDisabled={!selectedState}
                                                        isLoading={citiesLoading}
                                                        onChange={handleCityChange}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">Zone <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                                <Form.Item
                                                    name={["formDataList", index, "zone"]}
                                                    rules={[{ required: true, message: "Zone is required" }]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={userTypeOptions}
                                                        placeholder="Zone"
                                                        onChange={(selectedOption) => handleZoneChange(selectedOption, index)}
                                                    />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label>Select Manager</label>
                                                <Form.Item
                                                    name={["formDataList", index, "employeeIdOfManager"]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={managerOptions}
                                                        placeholder="Select Manager"
                                                        onChange={(selectedOption) =>
                                                            handleManagerSelect(selectedOption, index)
                                                        }
                                                        isSearchable
                                                        isClearable
                                                        isLoading={managersListLoading}
                                                        onInputChange={(inputValue) =>
                                                            setManagerSearchTerm(inputValue)
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>

                                        </Row>

                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className={formDataList[index]?.employeeIdOfManager ? "required-label" : ""}>
                                                    Date of Reporting </label>
                                                <Form.Item
                                                    name={["formDataList", index, "dateOfReporting"]}
                                                    dependencies={[["formDataList", index, "employeeIdOfManager"]]}
                                                    rules={[
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                const managerId = getFieldValue(["formDataList", index, "employeeIdOfManager"]);
                                                                if (managerId && !value) {
                                                                    return Promise.reject(new Error("Date of Reporting is required when Manager is selected!"));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <DatePicker
                                                        style={{ width: "100%" }}
                                                        placeholder="Date of Reporting"
                                                        onChange={(date) => handleListDateChange(index, "dateOfReporting", date)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label>Employee ID of Manager</label>
                                                <Form.Item
                                                    name={["formDataList", index, "employeeIdOfManager"]}
                                                >
                                                    <TextInputField
                                                        placeholder="Employee ID of Manager"
                                                        value={selectedManagerEmployeeId || "No Manager Selected"}
                                                        disabled
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={[16, 16]} className="registration-form-row">
                                            <Col xs={24} sm={12} md={12} lg={12}>
                                                <label className="required-label">User Type <span style={{ color: "#C21A17", marginLeft: "3px" }}>*</span></label>
                                                <Form.Item
                                                    name={["formDataList", index, "userType"]}
                                                    rules={[{ required: true, message: "User Type is required!" }]}
                                                >
                                                    <SelectDropdown
                                                        classNamePrefix="work-data-select"
                                                        options={userTypesOptions}
                                                        placeholder="Select User Type"
                                                        value={userTypesOptions.find(option => option.value === formDataList[index]?.userType) || null}
                                                        onChange={(selectedOption) => handleUserTypeChange(selectedOption, index)}
                                                        isSearchable
                                                    />
                                                </Form.Item>
                                                {touched[`${index}-userType`] && errors[`${index}-userType`] && (
                                                    <div className="createClientErrors">{errors[`${index}-userType`]}</div>
                                                )}
                                            </Col>
                                        </Row>
                                        {index > 0 && (
                                            <button
                                                type="button"
                                                className="user-management-cancel-button"
                                                onClick={() => removeUserFields(index)}
                                                style={{
                                                    marginTop: "10px",
                                                    backgroundColor: "#AD0101",
                                                    color: "white",
                                                    display: "flex",
                                                    justifySelf: "end",
                                                    alignItems: "center"
                                                }}
                                            >
                                                Remove User
                                            </button>
                                        )}
                                    </div>
                                ))}

                                <div className="global-admin-modal-footer-user-management" >
                                    <button
                                        type="button"
                                        className="user-management-cancel-button"
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="user-management-save-button"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent default refresh behavior
                                            const allFields = Object.keys(form.getFieldsValue());
                                            const fieldsToValidate = allFields.filter(field => field !== "branch" && field !== "cityName" && field !== "designation" && field !== "employeeType" && field !== "employeeIds" && field !== "joiningDate" && field !== "reportingDate" && field !== "stateName" && field !== "zone");
                                            form.validateFields()
                                                .then((values) => {
                                                    handleSubmit();
                                                })
                                                .catch((errorInfo) => {
                                                    console.log("Validation Failed:", errorInfo);
                                                });
                                        }}
                                        disabled={addUsersLoading}
                                        style={{ opacity: addUsersLoading ? 0.7 : 1, cursor: addUsersLoading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {addUsersLoading ? <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span> : 'Save'}
                                    </button>
                                </div>
                            </Form>
                        </>
                    )}
                </Form>
            </Modal>

            <Modal
                title="Bulk Lead Upload"
                open={isModalVisibleForUpload}
                onCancel={handleCancelUpload}
                footer={null}
                width={600}
                centered
                destroyOnClose
            >
                <div
                    style={{
                        padding: "20px",
                        textAlign: "center",
                        border: "2px dashed #ccc",
                        borderRadius: "8px",
                        cursor: "pointer"
                    }}
                    onClick={() => document.getElementById("fileUpload").click()} // Opens file input
                >
                    <div className="uploadIconOfAddUser">
                        <img src={BulkUploadFiles} alt="Upload Icon" />
                    </div>

                    <p style={{ fontSize: "16px", fontFamily: "Inter" }}>
                        Drag & Drop files or <span style={{ color: "#AD0101" }}>Browse</span>
                    </p>
                    <p style={{ color: "#666", fontSize: "12px", marginTop: "10px" }}>
                        Supported formats: xlsx
                    </p>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        id="fileUpload"
                        style={{ display: "none" }}
                        accept=".xlsx"
                        onChange={(e) => setFile(e.target.files[0])} // Store file on selection
                    />
                </div>

                {/* Show selected file name */}
                {file && (
                    <p style={{ textAlign: "center", marginTop: "10px", fontSize: "14px" }}>
                        File Selected: {file.name}
                    </p>
                )}

                {/* Upload button */}
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button
                        onClick={handleUpload}
                        disabled={!file}
                        style={{
                            background: "#FAC9CA",
                            color: "#9B9C9C",
                            border: "none",
                            padding: "8px 20px",
                            borderRadius: "4px",
                            transition: "background 0.3s ease-in-out",
                            cursor: file ? "pointer" : "not-allowed",
                            fontWeight: "500",
                            background: file ? "#AD0101" : "#FAC9CA", // Red when active, light pink when disabled
                            color: file ? "#FFF" : "#9B9C9C",
                        }}
                    >
                        Upload File
                    </button>
                </div>
            </Modal>

            <UploadModal
                title="Performance Upload"
                open={isModalVisibleForPerformanceUpload}
                onCancel={handleCancelPerformanceUpload}
                accountId={accountId}
                roleId={roleId}
                mutation={bulkUploadPerformance} // Replace with actual performance upload mutation if different
                onSuccess={handlePerformanceUploadSuccess}
            />
        </div >
    );
};

export default UserManagement;